import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/background_image.png'


const _hoisted_1 = { class: "h-screen bg-access_point-300 flex flex-col container" }
const _hoisted_2 = { class: "flex items-center w-full flex-col bg-white absolute bottom-0 container_footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderHome = _resolveComponent("HeaderHome")!
  const _component_SelectRooms = _resolveComponent("SelectRooms")!
  const _component_ModalLogout = _resolveComponent("ModalLogout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_HeaderHome, {
        title: "ACCESS POINT",
        "sub-title": "seguro e fácil",
        userName: _ctx.store.user?.name,
        showModalLogout: _ctx.showModal
      }, null, 8, ["userName", "showModalLogout"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_SelectRooms)
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_0,
        class: "img_home z-1 w-full"
      }, null, -1))
    ]),
    _createVNode(_component_ModalLogout, { ref: "modalRef" }, null, 512)
  ], 64))
}